import { SET_TOPBAR_COURSE_NAVIGATION_SEARCH_STRING } from './actions';

import './injectReducers';
import { makeMetricsLogEvent } from '../../../ReduxStorage/Metrics/manualEventDispatchers';

export const setTopbarCourseNavigationSearchString = (searchString) => (
  dispatch
) =>
  dispatch({
    type: SET_TOPBAR_COURSE_NAVIGATION_SEARCH_STRING,
    searchString,
  });

export const makeTopbarSearchSubmit = (searchString) => (dispatch) => {
  dispatch(
    makeMetricsLogEvent('Course-Searched', {
      action: 'top-bar',
      'search-string': searchString,
    })
  );
};
